import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const agentOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "公司名称",
            prop: "company",
            type: 'input',
            search:true,
            span: 12,
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "公司区域",
        //     prop: "address",
        //     type: 'input',
        //     hide: true,
        //     search:true,
        //     span: 18
        // },
        {
            label: "公司地址",
            prop: "address",
            type: 'input',
            span: 12,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "详细地址",
            prop: "detailAddress",
            type: 'input',
            span: 18,
            addVisdiplay: false,
            editVisdiplay: false
        },
        
        {
            label: "权限菜单",
            prop: "departId",
            solt: true,
            hide: true,
            formsolt: true,
            span: 24
        },
        // {
        //     label: "更新时间",
        //     prop: "createTime",
        //     type: "datetime",
        //     // sortable: true,
        //     valueFormat: "timestamp",
        //     format: "yyyy-MM-dd HH:mm:ss",
            // addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     width: "110"
        // },
    ]
};